var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-customer-componets-editor-preview"},[_c(_vm.componetPreview,{tag:"component",attrs:{"units":_vm.currentInfo.components,"menuInfo":_vm.currentInfo,"uuid":_vm.currentInfo.uuid,"pre":_vm.pre},on:{"update:units":function($event){return _vm.$set(_vm.currentInfo, "components", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }